import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ROUTES, { makeGroupSearchURL, makePeopleSearchURL } from 'routes';
import Icon from 'components/Icon';
import Typography from 'components/ui/Typography';

import css from './NavigationLinks.module.scss';

const NavigationLinks: React.FC = () => {
    const { t } = useTranslation();

    return (
        <ul className={css.list}>
            <li>
                <Link to={ROUTES.HOME} className={css.link}>
                    <Icon name="home" color="white" width={22} className={css.icon} />
                    <Typography style="HeadMedSemibold" color="white">
                        {t('Header.Home')}
                    </Typography>
                </Link>
            </li>
            <li>
                <Link to={makePeopleSearchURL()} className={css.link}>
                    <Icon name="search" color="white" width={22} className={css.icon} />
                    <Typography style="HeadMedSemibold" color="white">
                        {t('Header.Search')}
                    </Typography>
                </Link>
            </li>
            <li>
                <Link to={makeGroupSearchURL()} className={css.link}>
                    <Icon name="users-three" color="white" width={22} className={css.icon} />
                    <Typography style="HeadMedSemibold" color="white">
                        {t('Header.Groups')}
                    </Typography>
                </Link>
            </li>
        </ul>
    );
};

export default NavigationLinks;
